'use client';

import { ChevronRight } from 'lucide-react';
import React from 'react';

interface ScoreChange {
  date: string;
  reason: string;
  change: number;
}

interface ScoreHistoryProps {
  changes: ScoreChange[];
  onViewMore?: () => void;
}

/**
 * Displays recent reputation score changes.
 */
function ScoreHistory({ changes, onViewMore }: ScoreHistoryProps) {
  if (changes.length === 0) {
    return (
      <div className="space-y-3">
        <h3 className="font-semibold">Reputation Score History</h3>
        <p className="text-sm text-gray-500">No score changes yet. Start shopping to build your reputation!</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold">Reputation Score History</h3>
        {onViewMore && (
          <button
            onClick={onViewMore}
            className="flex items-center text-sm text-motitoBlue hover:underline"
          >
            View more
            <ChevronRight className="size-4" />
          </button>
        )}
      </div>

      <div className="space-y-2">
        {changes.slice(0, 3).map((item, index) => (
          <div
            key={index}
            className="flex items-center justify-between rounded-lg bg-gray-50 px-4 py-3"
          >
            <div>
              <p className="text-sm font-medium">{item.reason}</p>
              <p className="text-xs text-gray-500">{item.date}</p>
            </div>
            <span
              className={`font-semibold ${
                item.change >= 0 ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {item.change >= 0 ? '+' : ''}{item.change} units
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ScoreHistory;
